import type { ID } from '@octopus-do/octopus-project-core'

import type { Workspace } from '../types'

export const findTargetSpace = (id: ID, state: Workspace[]) =>
  state.find((w) => w.id === id)
